import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { GenderModel, TrainModel } from 'src/app/model/files.model';
import { CommonService } from 'src/app/services/common.service';
import { MyFilesService } from 'src/app/services/myfiles.service';
import { MessageService,ConfirmationService,ConfirmEventType } from 'primeng/api';

@Component({
  selector: 'app-voice-annotations',
  templateUrl: './voice-annotations.component.html',
  styleUrls: ['./voice-annotations.component.scss'],
  providers: [MessageService,ConfirmationService]
})

export class VoiceAnnotationsComponent {
  uploadForm!: FormGroup;
  submitData!: TrainModel;
  allGender: GenderModel[];
  isSubmitted: boolean;
  audio_url: string;
  email!:string;
  recording!:boolean;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private fileService: MyFilesService,
    private commonservice: CommonService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    this.audio_url = "";
    this.isSubmitted = false;
    this.allGender = [{"name":"Male"},{"name":"Female"}];
  }
  
  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      name: ["", Validators.required],
      email: ["", Validators.required],
      gender: [""],
      selectedGender: [],
      audio_url: ["", Validators.required]
    });
    this.commonservice.loggedInUser.subscribe((user:any) => {
      this.email = user.userPrincipalName;
    })
  }

  onRecording(recording: boolean) {
    this.recording = recording;
  }

  onRecordEvent(file: Blob) {
    if (file) {
      const formData = new FormData();  
      formData.append('file', file);
      formData.append('user_email', this.email);
      formData.append('db_store', false.toString());
      this.fileService.uploadFile(formData).subscribe((event: any) => {  
          if (typeof (event) === 'object') {  
            if(event.body) {
              debugger;
              this.audio_url = this.commonservice.get_storage_cdn_url(event.body.file_url);
              this.uploadForm.patchValue({
                audio_url: this.audio_url
              });
              this.cdr.detectChanges();
            }
          }  
      });   
    }
  }

  onUploadEvent(url: string) {
    this.uploadForm.patchValue({
      audio_url: url
    });
    this.audio_url = url;
    this.cdr.detectChanges();
  }

  /**
   * Handle onsubmit event for upload form
   */

  voice_training_status={}

  onSubmit() {
    this.isSubmitted = true;
    if (this.uploadForm.value.selectedGender) {
      this.uploadForm.patchValue({
        gender: this.uploadForm.value.selectedGender.name,
      });
    }
    if (this.uploadForm.valid) {
      this.submitData = {
        name: this.uploadForm.value.name,
        email: this.uploadForm.value.email,
        gender:this.uploadForm.value.gender,
        audio_url_list: [this.uploadForm.value.audio_url]
      };
      this.fileService.trainNewSpeaker(this.submitData).subscribe(
        (res: any) => {
          setTimeout(()=>{
            window.location.reload();
          },5000)
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Your Voice is Trained' });
        },
        (error) => {

          let errorMessage = 'An error occurred. Please try again.';
          if (error.status === 400 || error.status === 409) {
            errorMessage = error?.error?.message;
          }
          this.messageService.add({ severity: 'error', summary: 'Failure', detail: errorMessage });
          setTimeout(() => {
            window.location.reload();
          }, 5000)
        }
      );
    }
  }

  /**
   * For accessing form controls in view
   */
  get contentForm() {
    return this.uploadForm.controls;
  }

  goHome() {
    this.router.navigateByUrl("/AudioTranslation");
  }

  deleteRecords(){

    this.confirmationService.confirm({
      message: 'Do you want to delete all the Voice trained files present in Database?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.fileService.deleteRecordsInDb().subscribe((res: any) => {
          if (res.message == 'No documents were archived.') {
            this.messageService.add({ severity: 'warn', summary: 'Info', detail: 'No files are present in Database to be archived' });
          } else {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'All training files were archived from the Database. Please upload new audio samples to train speakers.' });
          }
        })
      },
      reject: (type: ConfirmEventType) => { 
          switch (type) {
              case ConfirmEventType.REJECT:
                  break;
              case ConfirmEventType.CANCEL:
                  break;
              default:
                  break;
          }
      }
  });

  }

}
